import React from "react";
import { withStyles } from "material-ui/styles";
import grey from "material-ui/colors/grey";
import classnames from "classnames";

const styles = {
  table: {
    borderCollapse: "collapse",
    width: "100%",
    border: `1px solid ${grey[300]}`
  }
};

const CTable = props => {
  const { children, classes, className, ...otherProps } = props;

  return (
    <table
      {...otherProps}
      border="1"
      className={classnames(classes.table, className)}
    >
      {children}
    </table>
  );
};

export default withStyles(styles)(CTable);



// WEBPACK FOOTER //
// ./src/uis/CTable/CTable.jsx